import React from 'react'
import { FormTextField } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'

export const NAME = 'zip'

export const ZipCodeField = ({ disabled }) => {
  const [t] = useTranslation()
  return (
    <FormTextField
      name={NAME}
      type="number"
      label={`${t('form.field.zip-code.label', 'Zip Code')} *`}
      disabled={disabled}
      required
      autoComplete="postal-code"
    />
  )
}
